import { LinearProgress } from "@mui/material";
import { useLogin } from "@refinedev/core";
import React, { useEffect } from "react";

export const Login: React.FC = () => {
  const { mutate: login } = useLogin();

  useEffect(() => login({}), []);

  return <LinearProgress />;
};
